// extracted by mini-css-extract-plugin
module.exports = {"postedBy":"e_xlb","postedByDate":"e_ylb","container":"e_zlb","description":"e_Alb","title":"e_Blb"};